import './FileUpload.scss';

import Button from 'components/button';
import React, { ComponentPropsWithoutRef } from 'react';
import { useTranslation } from 'react-i18next';

export interface IFileUploadProps extends ComponentPropsWithoutRef<'input'> {
  label?: string;
}

const FileUpload: React.FC<IFileUploadProps> = ({ label = '', className = '', ...props }) => {
  const { t } = useTranslation();

  return (
    <div className={['w-full relative overflow-hidden file-upload', className].join(' ')}>
      <input {...props} type='file' className='absolute cursor-pointer w-fit h-full left-0 top-0 opacity-0 z-10 file-upload__input' />
      <Button buttonVariant='tertiary' label={label || t('admin.label.update_image')} disabled={props.disabled} className='file-upload__button' />
    </div>
  );
};

export default FileUpload;
